import React from 'react';
import { Box, Button } from '@material-ui/core';
import { HeaderBar } from './UserRequestsStyles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import AutorenewIcon from '@material-ui/icons/Autorenew';

type SupportRequestHeaderProps = {
  onBack: () => void;
  onReassign: () => void;
  onEditStatus: () => void;
  canWrite?: boolean;
};

const SupportRequestHeader: React.FC<SupportRequestHeaderProps> = ({
  onBack,
  onReassign,
  onEditStatus,
  canWrite = true,
}) => {
  return (
    <HeaderBar>
      <Button
        startIcon={<ArrowBackIcon />}
        color="primary"
        style={{ fontWeight: 700 }}
        onClick={onBack}
      >
        Back
      </Button>
      <Box style={{ display: 'flex', alignItems: 'center', marginRight: 24 }}>
        {canWrite && (
          <>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AutorenewIcon />}
              onClick={onReassign}
              style={{ marginRight: 24 }}
            >
              Re-assign
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<EditIcon />}
              onClick={onEditStatus}
            >
              Edit Status
            </Button>
          </>
        )}
      </Box>
    </HeaderBar>
  );
};

export default SupportRequestHeader;
